// extracted by mini-css-extract-plugin
module.exports = {"marquee":"Marquee_marquee__eE4y1","items":"Marquee_items__jue2m","item":"Marquee_item__DaQsS"};